import Http from '@/utils/http'
const baseUrl = '/app/teacher'

/**
 *签到列表
 * @param params
 * 
*/

export const signList = params => Http.get(`${baseUrl}/activity/sign`, { params })

/**
 * 修改签到状态
 * @param params
 * 
*/

export const editSign = params => Http.put(`${baseUrl}/activity/sign`,  params )
